import api from "./api";

export const getWalletBalance = () => api.get("/wallet/balance");
// export const getWalletDashboard = () => api.get("/wallet/dashboard");
export const getWalletDashboard = () => api.get("/dashboard/summary");

export const getWalletTransactions = ({
  page = 1,
  limit = 10,
  fromDate = "",
  toDate = "",
  search = "",
  type = "",
} = {}) => {
  const params = new URLSearchParams({ limit, page });
  if (fromDate) params.append("from_date", fromDate);
  if (toDate) params.append("to_date", toDate);
  if (search) params.append("search", search);
  if (type) {
    params.append("type", type);
    params.append("transaction_type", type);
  }
  return api.get(`/wallet/transactions?${params.toString()}`);
};


